var React = require('react');
// import onClickOutside from 'react-onclickoutside';

class Dialog extends React.Component {

    render() {
        return (
            <div className="pubr-download" tabIndex="0">  
                <DialogInnerWrapper outsideClickHandler={this.props.outsideClickHandler}>              
                    {this.props.children}
                </DialogInnerWrapper>
            </div>
        );
    }
}

module.exports = Dialog;


class DialogInner extends React.Component {
    constructor(props) {
      super(props);
      this.handleClickOutside = this.handleClickOutside.bind(this);
      this.handleEscKey = this.handleEscKey.bind(this);
    }
    componentWillMount() {
        document.addEventListener('keydown', this.handleEscKey);
    }
    render() {
        return (   
            <div className="pubr-download__dialog">
                {this.props.children}
            </div>
        );
    }
    handleClickOutside(e) {
        this.props.outsideClickHandler();
    }
    handleEscKey(e) {
        if(e.key === "Escape") {
            document.removeEventListener('keydown', this.handleEscKey);
            this.props.outsideClickHandler();
        }
    }
}

// var DialogInnerWrapper = onClickOutside(DialogInner);
var DialogInnerWrapper = DialogInner;


// WEBPACK FOOTER //
// ./src/components/Dialog.js